export default class Reiseziel {
    /** PK: Reiseziel | erforderlich **/
    public reiseziel_id: number | null = null;
    /**  | max. 50 Zeichen | erforderlich **/
    public reiseziel: string | null = null;
    /**  | max. 50 Zeichen | erforderlich **/
    public bezeichnung: string | null = null;
    /** FK: Reiseziel **/
    public impfempfehlung_id: number | null = null;
    /**  | max. 1 Zeichen | erforderlich **/
    public gueltig: string | null = 'j';

    public impfempfehlung: string | null = null;

    constructor(data?: Partial<Reiseziel>) {
        Object.assign(this, data);
    }
}
